<template>
	<span v-if="iCan('view', 'Orders')">
		<v-dialog v-model="dialog" max-width="1700px" scrollable persistent v-if="scopeorder">
			<v-card>
				<v-card-title class="bb-1">
					<span class="headline">{{ (viewform ? 'View' : 'New') }} {{ (type === 'purchase-order' ? 'Purchase Order' : 'Order') }}</span>
					<v-spacer></v-spacer>
					<order-exports
						v-if="iCan('view', 'Exports') && myexports.length && viewform"
						:type="type"
						:customer="customer"
						:keyedFieldValues="keyedFieldvalues"
						:order="order"></order-exports>
					<v-btn icon @click="toggleLog" v-if="viewform">
						<v-icon>mdi-history</v-icon>
					</v-btn>
					<v-menu
						v-if="!editDisabled && scopeorder.configuration"
						bottom
						left
						:close-on-content-click="false">
						<template v-slot:activator="{ on }">
							<v-btn v-on="on" icon>
								<v-icon>more_vert</v-icon>
							</v-btn>
						</template>
						<v-card>
							<v-card-text>
								<v-switch label="Field Assignments" :input-value="scopeorder.configuration.fieldassignments" hide-details @click="switchAssignments('fields')" class="mt-0"></v-switch>
								<v-switch label="Price Assignments" :input-value="scopeorder.configuration.priceassignments" hide-details @click="switchAssignments('prices')"></v-switch>
							</v-card-text>
						</v-card>
					</v-menu>
				</v-card-title>
				<v-card-text class="pa-0">
					<v-form ref="orderform" :key="scopeorder.id">
						<v-card-text v-if="orderFieldsTop.length" class="transparent-darken-1">
							<v-container grid-list-lg pa-0>
								<field-form
									ref="fieldformtop"
									:assignment_type="type"
									:assignment_id="scopeorder.id"
									:availableassignments="availableassignments"
									:columns="columns"
									:fields="orderFieldsTop"
									:keyedFieldvalues="keyedFieldvalues"
									:overrides="overrides"
									:setDefault="!viewform"
									:viewform="viewform"
									:inlineEdit="viewform"
									:inlineSave="inlineSave"
									@inputChanged="OrderChanged"
									:editDisabled="editDisabled"
									></field-form>
							</v-container>
						</v-card-text>
						<v-data-table
							hide-default-footer
							:class="{
								'bt-1' : orderFieldsTop.length,
								'bb-1' : orderFieldsBottom.length
							}"
							:items="scopeorder.orderitems"
							:items-per-page="-1"
							:headers="rowHeaders">

							<order-row
								:ref="'orderrow'+props.index"
								slot="item"
								slot-scope="props"
								:type="type"
								:availableassignments="availableassignments"
								:customerField="customerField"
								:department="department"
								:editing="(viewform && props.item.id && editingRows.indexOf(props.item.id) < 0 ? false : true)"
								:editDisabled="editDisabled"
								:fields="orderitemFields"
								:highlight="(props.item.id && department && department.id && scopeorder.configuration['h'+department.id].indexOf(props.item.id) > -1)"
								:key="props.item.id"
								:keyedFieldvalues="keyedFieldvalues"
								:order_id="scopeorder.id"
								:overrides="overrides"
								:priceOverrides="priceOverrides"
								:productField="productField"
								:row="props.item"
								:rowindex="props.index"
								:setprices="scopeorder.configuration.priceassignments"
								:viewform="viewform"
								:inlineSave="inlineSave"
								:canEditItems="canEditItems"
								:assignment_type="type"
								@deleteOrderitem="deleteOrderitem"
								@OrderChanged="OrderChanged"
								@priceChanged="priceChanged"
								@pricetypeChanged="pricetypeChanged"
								@setEdit="setEdit"
								@totalChanged="totalChanged"
								@highlightItem="highlightItem"
								></order-row>

							<div slot="footer" class="os-order-footer" :class="{'editing' : editing}" v-if="priceOverrides.total.visibility === 'visible' && scopeorder.orderitems.length > 1">
								<div class="px-2">
									<!-- <span v-if="!editing" class="subheading">
										{{ totalPrice }}
									</span> -->
									<v-text-field
										label="Total"
										prefix="£"
										readonly
										:value="totalPrice | price"></v-text-field>
								</div>
							</div>
						</v-data-table>
						<v-card-text v-if="orderFieldsBottom.length" class="transparent-darken-1">
							<v-container grid-list-lg pa-0>
								<field-form
									ref="fieldformbottom"
									:assignment_type="type"
									:assignment_id="scopeorder.id"
									:availableassignments="availableassignments"
									:columns="columns"
									:fields="orderFieldsBottom"
									:keyedFieldvalues="keyedFieldvalues"
									:overrides="overrides"
									:setDefault="!viewform"
									:viewform="viewform"
									:inlineEdit="viewform"
									:inlineSave="inlineSave"
									@inputChanged="OrderChanged"
									:editDisabled="editDisabled"></field-form>
							</v-container>
						</v-card-text>
					</v-form>
				</v-card-text>
				<v-card-actions class="bt-1 fixed-actions">
					<v-btn color="error" :dark="darks.error" :light="!darks.error" @click.native="deleteOrder()" v-if="iCan('delete', 'Orders') && viewform && canDeleteOrder">
						Delete
						<v-icon right :dark="darks.error" :light="!darks.error">mdi-delete-outline</v-icon>
					</v-btn>
					<v-btn color="success" :dark="darks.success" :light="!darks.success" @click.native="addOrderitem()" v-if="!editDisabled && canEditItems">
						Product row
						<v-icon right :dark="darks.success" :light="!darks.success">mdi-plus-circle-outline</v-icon>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn :disabled="$store.state.processing" text @click.native="closeOrder()">Close</v-btn>
					<v-btn v-if="!viewform || !inlineSave" color="success" :dark="darks.success" :light="!darks.success" @click.native="saveOrder()">
						Save
						<v-icon right :dark="darks.success" :light="!darks.success">mdi-check-outline</v-icon>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="showLog" max-width="600px">
            <v-card>
				<v-card-title class="bb-1">
					<span class="headline">Order history</span>
				</v-card-title>
				<v-simple-table>
					<template v-slot:default>
						<tbody>
							<tr v-for="log in order.logs" :key="log.time">
								<td>{{ log.user }}</td>
								<td>{{ log.action }}</td>
								<td>{{ log.created_at | datetime }}</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
				<v-card-actions class="bt-1 fixed-actions">
					<v-spacer></v-spacer>
					<v-btn text @click="toggleLog">Close</v-btn>
				</v-card-actions>
            </v-card>
		</v-dialog>
	</span>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { helpers } from '../../store/helpers.js';
	import FieldForm from '../shared/FieldForm';
	import FieldInput from '../shared/FieldInput';
	import OrderRow from './OrderRow';
	import OrderExports from '../shared/OrderExports';

    export default {
        components: {
			'field-form': FieldForm,
			'field-input': FieldInput,
			'order-row': OrderRow,
			'order-exports': OrderExports
		},
		computed: {
			...mapGetters([
		    	'keyedCustomers',
				'keyedPosttypes',
				'keyedPosttypeItems'
			]),
			customerField() {
				return (this.type === 'purchase-order') ? this.$store.getters.po_customerField : this.$store.getters.customerField;
			},
			dateField() {
				return (this.type === 'purchase-order') ? this.$store.getters.po_dateField : this.$store.getters.dateField;
			},
			orderpriceField() {
				return (this.type === 'purchase-order') ? this.$store.getters.po_orderpriceField : this.$store.getters.orderpriceField;
			},
			priceField() {
				return (this.type === 'purchase-order') ? this.$store.getters.po_priceField : this.$store.getters.priceField;
			},
			pricetypeField() {
				return (this.type === 'purchase-order') ? this.$store.getters.po_pricetypeField : this.$store.getters.pricetypeField;
			},
			productField() {
				return (this.type === 'purchase-order') ? this.$store.getters.po_productField : this.$store.getters.productField;
			},
			totalField() {
				return (this.type === 'purchase-order') ? this.$store.getters.po_totalField : this.$store.getters.totalField;
			},
			customer() {
				return this.keyedCustomers[this.order.customer_id];
			},
			myexports() {
				return this.$store.state.exports;
			},
			inlineSave() {
				return this.department && this.department.configuration.inlineSave;
			},
			canEditItems() {
				return !this.department || this.department.configuration.edit_items;
			},
			canDeleteOrder() {
				return this.department && this.department.configuration.delete_order;
			},
			editDisabled() {
				if(this.viewform && this.iCan('edit', 'Orders'))
					return false;
				if(!this.viewform && this.iCan('create', 'Orders'))
					return false;
				return true;
			},
            keyedFieldvalues () {
                let values = {},
					included_posttypes = [];
				for(let x = 0, value; value = this.scopeorder.fieldvalues[x]; x++){
					if(!values[value.field_id]){
                        values[value.field_id] = value;
					}
				}

				if(this.scopeorder.orderitems){
					for(let x = 0, orderitem; orderitem = this.scopeorder.orderitems[x]; x++){
						for(let y = 0, itemvalue; itemvalue = orderitem.fieldvalues[y]; y++){
							if(!values[itemvalue.field_id])
		                        values[itemvalue.field_id] = { orderitem: true };
							if(!values[itemvalue.field_id][x])
								values[itemvalue.field_id][x] = itemvalue;
						}
					}
				}

				for(let x = 0, field; field = this.orderFields[x]; x++){
					if(!values[field.id]){
						let assignment_type = (field.assignment_type === 'purchase-order' ? 'order' : (field.assignment_type === 'purchase-orderitem' ? 'orderitem' : field.assignment_type));
						values[field.id] = Object.assign({field_id: field.id, assignment_type}, this.defaultValue);
						if(field.configuration.multiselect && (field.type === 'select' || field.type === 'posttype')){
                            values[field.id].value = [];
                            values[field.id].format = 'array';
                        }
                        if(field.type === 'checkbox'){
                            values[field.id].value = false;
                            values[field.id].format = 'boolean';
                        }
						if(field.type === 'integer')
                            values[field.id].format = 'integer';
						if(field.type === 'deciaml')
							values[field.id].format = 'float';
						if(field.type === 'file')
                            values[field.id].format = 'object';
					}else if(field.type === 'posttype'){
						let posttype_item_ids = (field.configuration.multiselect) ? values[field.id].value : [values[field.id].value];
						for(let xx = 0, posttype_item_id; posttype_item_id = posttype_item_ids[xx]; xx++){
							let posttype_item = this.keyedPosttypeItems[posttype_item_id];
							for(let xxx = 0, posttype_value; posttype_value = posttype_item.fieldvalues[xxx]; xxx++) {
								if(!values[posttype_value.field_id])
									values[posttype_value.field_id] = (field.configuration.multiselect) ? [] : null;
								
								if(field.configuration.multiselect){
									values[posttype_value.field_id].push(posttype_value);
								}else{
									values[posttype_value.field_id] = posttype_value;
								}
							}
							included_posttypes.push({ id: field.configuration.posttype, multiselect: field.configuration.multiselect, orderitem: false });
						}
					}
				}

				for(let x = 0, itemfield; itemfield = this.orderitemFields[x]; x++){
					if(!values[itemfield.id])
						values[itemfield.id] = { orderitem: true };
					for(let y = this.scopeorder.orderitems.length - 1; y >= 0; y--){
						if(!values[itemfield.id][y]){
							let assignment_type = (itemfield.assignment_type === 'purchase-order' ? 'order' : (itemfield.assignment_type === 'purchase-orderitem' ? 'orderitem' : itemfield.assignment_type));
							values[itemfield.id][y] = Object.assign({field_id: itemfield.id, assignment_type}, this.defaultValue);
							if(itemfield.configuration.multiselect && field.type === 'select'){
								values[itemfield.id][y].value = [];
								values[itemfield.id][y].format = 'array';
							}
							if(itemfield.type === 'checkbox'){
								values[itemfield.id][y].value = false;
								values[itemfield.id][y].format = 'boolean';
							}
							if(itemfield.type === 'integer')
	                            values[itemfield.id][y].format = 'integer';
							if(itemfield.type === 'decimal')
	                            values[itemfield.id][y].format = 'float';
							if(itemfield.type === 'file')
								values[itemfield.id][y].format = 'object';
						}else if(itemfield.type === 'posttype'){
							let posttype_item_ids = (itemfield.configuration.multiselect) ? values[itemfield.id][y].value : [values[itemfield.id][y].value];
							for(let xx = 0, posttype_item_id; posttype_item_id = posttype_item_ids[xx]; xx++){
								let posttype_item = this.keyedPosttypeItems[posttype_item_id];
								for(let xxx = 0, posttype_value; posttype_value = posttype_item.fieldvalues[xxx]; xxx++) {
									if(!values[posttype_value.field_id][y])
										values[posttype_value.field_id][y] = (itemfield.configuration.multiselect) ? [] : null;
									
									if(itemfield.configuration.multiselect){
										values[posttype_value.field_id][y].push(posttype_value);
									}else{
										values[posttype_value.field_id][y] = posttype_value;
									}
								}
								included_posttypes.push({ id: itemfield.configuration.posttype, multiselect: itemfield.configuration.multiselect, orderitem: true });
							}
						}
					}
				}

				if(this.type === 'order') {
					if(values[this.customerField.id].value){
						if(this.keyedCustomers[values[this.customerField.id].value]){
							for(let x = 0, value; value = this.keyedCustomers[values[this.customerField.id].value].fieldvalues[x]; x++){
								if(!values[value.field_id])
									values[value.field_id] = value;
							}
						}
					}
				}

				for(let x = 0, included_posttype; included_posttype = included_posttypes[x]; x++) {
					let posttype = this.keyedPosttypes[included_posttype.id];
					for(let xx = 0, field; field = posttype.fields[xx]; xx++) {
						if(posttype.orderitem) {
							if(!values[field.id])
								values[field.id] = { orderitem: true };
							for(let xxx = 0; xxx < this.scopeorder.orderitems.length; xxx++){
								if(!values[field.id][xxx]){
									let assignment_type = (field.assignment_type === 'purchase-order' ? 'order' : (field.assignment_type === 'purchase-orderitem' ? 'orderitem' : field.assignment_type));
									values[field.id][xxx] = Object.assign({field_id: field.id, assignment_type}, this.defaultValue);
									if(posttype.multiple || (field.configuration.multiselect && field.type === 'select')){
										values[field.id][xxx].value = [];
										values[field.id][xxx].format = 'array';
									}
									if(field.type === 'checkbox'){
										values[field.id][xxx].value = false;
										values[field.id][xxx].format = 'boolean';
									}
									if(field.type === 'integer')
										values[field.id][xxx].format = 'integer';
									if(field.type === 'decimal')
										values[field.id][xxx].format = 'float';
									if(field.type === 'file')
										values[field.id][xxx].format = 'object';
								}
							}
						}else{
							if(!values[field.id]){
								let assignment_type = (field.assignment_type === 'purchase-order' ? 'order' : (field.assignment_type === 'purchase-orderitem' ? 'orderitem' : field.assignment_type));
								values[field.id] = Object.assign({field_id: field.id, assignment_type}, this.defaultValue);
								if(posttype.multiple || (field.configuration.multiselect && field.type === 'select')){
									values[field.id].value = [];
									values[field.id].format = 'array';
								}
								if(field.type === 'checkbox'){
									values[field.id].value = false;
									values[field.id].format = 'boolean';
								}
								if(field.type === 'integer')
									values[field.id].format = 'integer';
								if(field.type === 'decimal')
									values[field.id].format = 'float';
								if(field.type === 'file')
									values[field.id].format = 'object';
							}							
						}
					}
				}

                return values;
            },
			orderFields() {
				return this.$store.state.fields.filter(field => {
					if(field.assignment_type === this.type && field.internal_name !== 'order_price')
						return true;
					return false;
				}).sort((a,b) => {
					return (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0);
				});

			},
			orderFieldItemPosition() {
				let position = 0,
					lastposition = 0;
				for(let x = 0, field; field = this.orderFields[x]; x++){
					if(field.position > lastposition + 1){
						position = lastposition + 1;
						break
					}
					lastposition = field.position;
				}
				if(!position)
					position = this.orderFields.length + 1
				return position;
			},
			orderFieldsTop() {
				let fields = _.cloneDeep(this.orderFields);
				return fields.splice(0, this.orderFieldItemPosition - 1);
			},
			orderFieldsBottom() {
				let fields = _.cloneDeep(this.orderFields);
				return fields.splice(this.orderFieldItemPosition - 1);
			},
			orderitemFields() {
				return this.$store.state.fields.filter(field => {
					if(field.assignment_type === (this.type + 'item'))
						return true;
					return false;
				}).sort((a,b) => {
					return (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0);
				});
			},
			rowHeaders () {
				let headers = [],
					first = true,
					statusfields = [];
				for( let x = 0, field; field = this.orderitemFields[x]; x++){
					let visibility = field.configuration.visibility,
						obj = { sortable: false };
					if(['price_type', 'price', 'total'].indexOf(field.internal_name) === -1){
						if(this.overrides && this.overrides[field.id])
							visibility = this.overrides[field.id].visibility;

						if(!this.viewform && field.configuration.hide_new_order)
							visibility = 'hidden';

						if(visibility === 'hidden'){
							obj.class = 'pa-0';
						}else{
							obj.text = field.name;
							obj.class = (field.type === 'status' ? 'px-4 shrink-width' : 'px-2');
						}

						if(field.type === 'status'){
							statusfields.push(obj);
						}else{
							if(first){
								obj.class = ['pl-4', 'pr-2'];
								first = false;
							}
							headers.push(obj);
						}
					}
				}
				if(this.$store.state.pricetypes.length > 1){
					headers.push({
						class: (this.priceOverrides['pricetype'].visibility === 'visible' ? 'px-2' : 'px-0'),
						text: (this.priceOverrides['pricetype'].visibility === 'visible' ? 'Price type' : ''),
						sortable: false
					});
				}
				headers = headers.concat([{
					class: (this.priceOverrides['price'].visibility === 'visible' ? 'px-2' : 'px-0'),
					text: (this.priceOverrides['price'].visibility === 'visible' ? 'Price' : ''),
					sortable: false
				},{
					class: (this.priceOverrides['total'].visibility === 'visible' ? 'px-2' : 'px-0'),
					text: (this.priceOverrides['total'].visibility === 'visible' ? 'Total' : ''),
					sortable: false
				}]);
				if(!this.editDisabled){
					headers.push({
						class: 'px-0',
						sortable: false
					});
				}
				headers = headers.concat(statusfields);
				return headers;
			},
			totalPrice () {
				let price = null;
				if(this.scopeorder.orderitems){
					for(let x = 0, orderitem; orderitem = this.scopeorder.orderitems[x]; x++){
						if(orderitem.total){
							if(!price)
								price = 0;
							price = price + parseFloat(orderitem.total);
						}
					}
				}
				if(price)
					price = price.toFixed(2);
				return price;
			},
			priceOverrides() {
				let obj = {
					'pricetype': { read_only: false, visibility: 'visible' },
					'price': { read_only: false, visibility: 'visible' },
					'total': { read_only: false, visibility: 'visible' }
				};
				if(this.overrides){
					if(this.overrides[this.priceField.id]){
						obj['price'].read_only = this.overrides[this.priceField.id].read_only;
						obj['price'].visibility = this.overrides[this.priceField.id].visibility;
					}
					if(this.overrides[this.pricetypeField.id]){
						obj['pricetype'].read_only = this.overrides[this.pricetypeField.id].read_only;
						obj['pricetype'].visibility = this.overrides[this.pricetypeField.id].visibility;
					}
					if(this.overrides[this.totalField.id]){
						obj['total'].read_only = this.overrides[this.totalField.id].read_only;
						obj['total'].visibility = this.overrides[this.totalField.id].visibility;
					}
				}
				return obj;
			}
		},
		data() {
			return {
				availableassignments: {},
				dialog: false,
				columns: {
					date: 'date',
					customer: 'customer_id'
				},
				defaultOrder: {
					assignment_type: this.type,
					customer_id: null,
					date: null,
					fieldvalues: [],
					orderitems: [],
					configuration: {}
				},
				defaultOrderConfiguration: {
					fieldassignments: true,
					priceassignments: true
				},
				defaultOrderItem: {
					fieldvalues: [],
					pricetype_id: (this.$store.state.pricetypes.length === 1 ? this.$store.state.pricetypes[0].id : null),
					price: null,
					product_id: null,
					total: null
				},
                defaultValue:{
					format: null,
                    value: null
                },
				editing: (this.viewform ? false : true),
				editingRows: [],
				scopeorder: false,
				showLog: false
			}
		},
		filters: {
  			price: function (value) {
				if(!value) return '';
    			return parseFloat(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  			}
		},
        methods: {
			generateAssignments() {
				let availableassignments = {},
					possibleassignments = this.$store.state.fieldassignments.slice().sort((a,b) => {
						return (!a.priority && !b.priority || a.priority === b.priority) ? 0 : ((!b.priority || a.priority < b.priority) ? 1 : -1);
					});

				for(let x = 0, assignment; assignment = possibleassignments[x]; x++){
					for(let x = 0, action; action = assignment.actions[x]; x++){
						if(this.scopeorder.configuration.fieldassignments || action.action === 'visibility'){
							if(!availableassignments[action.field_id])
								availableassignments[action.field_id] = [];
							availableassignments[action.field_id].push(assignment);
						}
					}
				}

				this.availableassignments = availableassignments;
			},
			toggleLog() {
				this.showLog = !this.showLog;
			},
			addOrderitem () {
				if(this.canEditItems){
					let orderitem = Object.assign({ saved: false }, _.cloneDeep(this.defaultOrderItem)),
						fieldIds = (this.type === 'purchase-order') ? this.$store.getters.poFieldIds : this.$store.getters.fieldIds;
					this.scopeorder.orderitems.push(helpers.pushOrderitemValues({ orderitem, fieldIds }));
				}
			},
            closeOrder () {
				this.dialog = false;
                setTimeout(() => {
					this.scopeorder = false;
					this.editingRows = [];
					this.$emit('closeDialog');
                }, 300);
            },
			deleteOrder () {
				if(this.canDeleteOrder){
					Swal.fire({
						title: "Are you sure?",
						text: "Once deleted, you will not be able to undo this action.",
						type: "warning",
						allowOutsideClick: false,
						showCancelButton: true,
						reverseButtons: true,
						confirmButtonColor: '#d33',
						confirmButtonText: 'Yes, delete it!'
					})
					.then((result) => {
						if (result.value) {
							this.$store.dispatch('set', { name: 'processing', value: true });
							axios.delete('/api/orders/'+this.order.id)
							.then(response => {
								Swal.fire({
									title: response.data.message,
									type: 'success',
									timer: 1200,
									showConfirmButton: false
								});
								this.closeOrder();
								this.$store.dispatch('remove', { name: 'orders', data: this.order });
							}).catch(e => {
								Swal.fire({
									title: 'Unable to delete order',
									type: 'error',
									timer: 1500,
									showConfirmButton: false
								});
								this.errors.push(e.data);
							}).then(response => {
								this.$store.dispatch('set', { name: 'processing', value: false });
							});;
						}
					});
				}
			},
			deleteOrderitem (index, rowid) {
				if(this.canEditItems){
					this.scopeorder.orderitems.splice(index, 1);

					if(this.viewform && rowid){
						this.$store.dispatch('change', {
							name: 'orders',
							data: this.scopeorder
						});
					}
				}
			},
			highlightItem(rowid) {
				let property = 'h' + this.department.id,
					value = _.cloneDeep(this.scopeorder.configuration[property]),
					index = value.indexOf(rowid);

				if(index > -1){
					value.splice(index, 1);
				}else{
					value.push(rowid);
				}
				this.scopeorder.configuration[property] = value;
				this.$store.dispatch('change', {
					name: 'orders',
					data: { id: this.scopeorder.id, value },
					property,
					config: true
				});
				this.$store.dispatch('set', { name: 'processing', value: true });
				axios.post('/api/order/config', {id: this.scopeorder.id, property, value, default: false}).catch(e => {
					this.$store.dispatch('setSnack', { state: 'error', text: 'Error updating status' });
				}).then(() => {
					this.$store.dispatch('set', { name: 'processing', value: false });
				});
			},
			OrderChanged (values, rowindex = false, pricetype = false, price, total = false, rowid) {
				let fieldvalues = (rowindex !== false) ? this.scopeorder.orderitems[rowindex].fieldvalues : this.scopeorder.fieldvalues;
				if(!Array.isArray(values))
					values = [values]

				for(let x = 0, val; val = values[x]; x++){
					if(val.field_id === this.productField.id){
						this.scopeorder.orderitems[rowindex].product_id = val.value;
					}else if(val.field_id === this.customerField.id){
						this.scopeorder.customer_id = val.value;
					}else if(val.field_id === this.dateField.id){
						this.scopeorder.date = val.value;
					}

					let oldVal = fieldvalues.filter(function(value){
	                    if(val.field_id === value.field_id)
	                        return true;
	                    return false;
	                });
	                if(!oldVal.length && !!val.value && val.value.length !== 0){
	                    fieldvalues.push(_.cloneDeep(val));
	                }else if(oldVal.length && (!val.value || val.value.length === 0)){
	                    const index = fieldvalues.indexOf(oldVal[0]);
						fieldvalues.splice(index, 1);
	                }else if(oldVal.length){
						const index = fieldvalues.indexOf(oldVal[0]);
						Vue.set(fieldvalues, index, _.cloneDeep(val));
					}
				}

				if(pricetype !== false || total !== false){
					if(pricetype !== false){
						this.pricetypeChanged(pricetype, rowindex);
						this.priceChanged(price, rowindex);
					}
					if(total !== false){
						this.totalChanged(total, rowindex);
					}
				}

				let editingindex = this.editingRows.indexOf(rowid);
				if(rowid && editingindex > -1)
					this.editingRows.splice(editingindex, 1);

				if(rowindex && !this.scopeorder.orderitems[rowindex].id && rowid)
					this.scopeorder.orderitems[rowindex].id = rowid;

				if(this.viewform){
					let data = _.cloneDeep(this.scopeorder);
					for(let x = data.orderitems.length -1; x >= 0; x--){
						if(!data.orderitems[x].id)
							data.orderitems.splice(x, 1);
					}
					this.$store.dispatch('change', { name: 'orders', data });
				}
            },
			priceChanged (price, index){
				let valueindex = _.findIndex(this.scopeorder.orderitems[index].fieldvalues, ['field_id', this.priceField.id]);
				if(valueindex > -1)
					this.scopeorder.orderitems[index].fieldvalues[valueindex].value = price
				this.scopeorder.orderitems[index].price = price;
			},
			pricetypeChanged(value, index) {
				let valueindex = _.findIndex(this.scopeorder.orderitems[index].fieldvalues, ['field_id', this.pricetypeField.id]);
				if(valueindex > -1)
					this.scopeorder.orderitems[index].fieldvalues[valueindex].value = value
				this.scopeorder.orderitems[index].pricetype_id = value;
			},
			saveOrder () {
                if(this.$refs.orderform.validate()){
					if(this.viewform){
						let fieldsToSave = [],
							pricesToSave = [],
							rowsToSave = [],
							formref = [this.$refs.fieldformtop, this.$refs.fieldformbottom],
							data = new FormData(),
							files = [];
						for(let x = 0, form; form = formref[x]; x++){
							for(let y = 0, field; field = form.$refs.field[y]; y++){
								if(!_.isEqual(field.value, field.scopevalue)){
								// 	field.editing = false;
								// }else{
									let scopeval = _.cloneDeep(field.scopevalue);
									if(scopeval.value && typeof scopeval.value === 'object' && typeof scopeval.value.name === 'string'){
										data.append('files[]', scopeval.value);
										scopeval.value = scopeval.value.name;
									}else if(typeof scopeval.value === 'undefined'){
										scopeval.value = null
									}
									fieldsToSave.push({
										assignment_id: field.assignment_id,
										assignment_type: (field.assignment_type === 'purchase-order' ? 'order' : (field.assignment_type === 'purchase-orderitem' ? 'orderitem' : field.assignment_type)),										
										value: scopeval,
										column:  field.column
									});
								}
							}
						}
						for(let w = 0; w < this.scopeorder.orderitems.length; w++){
							let rowobj = this.$refs['orderrow'+w],
								fieldvalues = [],
								product_id = null;
							for(let x = 0, field; field = rowobj.$refs.childinput[x]; x++){
								let fieldval = _.cloneDeep(field.scopevalue);
								if(fieldval.field_id === this.productField.id)
									product_id = fieldval.value;
								if(field.editing){
									if(!_.isEqual(field.value, fieldval)){
										let index = _.findIndex(rowobj.scopevalues, ['field_id', field.scopevalue.field_id]),
											scopevalue = {
												assignment_id: field.assignment_id,
												assignment_type: (field.assignment_type === 'purchase-order' ? 'order' : (field.assignment_type === 'purchase-orderitem' ? 'orderitem' : field.assignment_type)),
												value: field.scopevalue,
												column:  field.column
											};

										if(index > -1){
											rowobj.scopevalues.splice(index, 1, scopevalue.value);
										}else{
											rowobj.scopevalues.push(scopevalue.value);
										}

										if(fieldval.value && typeof fieldval.value === 'object' && typeof fieldval.value.name === 'string'){
											data.append('files[]', fieldval.value);
											fieldval.value = fieldval.value.name;
										}else if(typeof fieldval.value === 'undefined'){
											fieldval.value = null
										}

										if(rowobj.inlineEdit){
											fieldsToSave.push({
												assignment_id: field.assignment_id,
												assignment_type: (field.assignment_type === 'purchase-order' ? 'order' : (field.assignment_type === 'purchase-orderitem' ? 'orderitem' : field.assignment_type)),
												value: fieldval,
												column:  field.column
											});
										}
									}
								}
								fieldvalues.push(fieldval);
							}
							// rowobj.scopevalues = [];
							if(rowobj.inlineEdit){
								if(rowobj.editingprice){
									pricesToSave.push({
										id: rowobj.id,
										pricetype_id: rowobj.scopepricetype,
										price: rowobj.scopeprice,
										total: rowobj.rowPrice
									});
								}
							}else{
								if(rowobj.editing){
									rowsToSave.push({
										fieldvalues,
										order_id: rowobj.order_id,
										id: rowobj.row.id,
										pricetype_id: rowobj.scopepricetype,
										price: rowobj.scopeprice,
										product_id: product_id,
										total: rowobj.rowPrice
									});
								}
							}
						}
						if(fieldsToSave.length || pricesToSave.length || rowsToSave.length){
							this.$store.dispatch('set', { name: 'processing', value: true });
							data.append('_method', 'PATCH')
							if(fieldsToSave.length)
								data.append('fieldsToSave', JSON.stringify(fieldsToSave));
							if(pricesToSave.length)
								data.append('pricesToSave', JSON.stringify(pricesToSave));
							if(rowsToSave.length)
								data.append('rowsToSave', JSON.stringify(rowsToSave));

							axios.post('/api/orders/'+this.scopeorder.id, data)
							.then(
								response => {
									this.$store.dispatch('set', { name: 'processing', value: false });
									let orderobj = response.data.order;
									this.$store.dispatch('addOrUpdate', {name: 'orders', data: orderobj});
									this.$store.dispatch('setSnack', { state: 'success', text: response.data.message });
									this.$refs.orderform.resetValidation();
									this.closeOrder();
								}
							)
							.catch(e => {
								this.$store.dispatch('set', { name: 'processing', value: false });
								this.$store.dispatch('setSnack', { state: 'error', text: 'Unable to save order' });
								this.errors.push(e.data);
							});
						}else{
							this.closeOrder();
						}
					}else{
						this.$store.dispatch('set', { name: 'processing', value: true });
						let order = _.cloneDeep(this.scopeorder),
							data = new FormData();
						for (var property in order.configuration) {
							if (order.configuration.hasOwnProperty(property)) {
								if(order.configuration[property] === this.defaultOrderConfiguration[property]){
									delete order.configuration[property];
								}
							}
						}
						for(let x = 0, fieldval; fieldval = order.fieldvalues[x]; x++){
							if(fieldval.value && typeof fieldval.value === 'object' && typeof fieldval.value.name === 'string'){
								data.append('files[]', fieldval.value);
								order.fieldvalues[x].value = fieldval.value.name;
							}else if(typeof fieldval.value === 'undefined'){
								order.fieldvalues[x].value = null
							}
						}
						for(let y = 0, orderitem; orderitem = order.orderitems[y]; y++){
							for(let x = 0, fieldval; fieldval = orderitem.fieldvalues[x]; x++){
								if(fieldval.value && typeof fieldval.value === 'object' && typeof fieldval.value.name === 'string'){
									data.append('files[]', fieldval.value);
									order.orderitems[y].fieldvalues[x].value = fieldval.value.name;
								}else if(typeof fieldval.value === 'undefined'){
									order.orderitems[y].fieldvalues[x].value = null
								}
							}
						}
						data.append('order', JSON.stringify(order));
						data.append('customerfield_id', this.customerField.id);
						axios.post('/api/orders', data)
						.then(
							response => {
								let orderobj = response.data.order,
									newcustomer = response.data.newcustomer;

								if(newcustomer)
									this.$store.dispatch('add', { name: 'customers', data: newcustomer });

								orderobj.configuration = Object.assign(orderobj.configuration, this.defaultOrderConfiguration);
								this.$store.dispatch('add', { name: 'orders', data: orderobj });
								this.$store.dispatch('setSnack', { state: 'success', text: response.data.message });
								this.$refs.orderform.resetValidation();
								this.closeOrder();
								if(response.data.log)
									this.$store.dispatch('addOrderLog', { id: response.data.order.id, log: response.data.log });
							}
						)
						.catch(e => {
							this.$store.dispatch('setSnack', { state: 'error', text: 'Unable to save order' });
							this.errors.push(e.data);
						}).then(() => {
							this.$store.dispatch('set', { name: 'processing', value: false });
						});
					}
                }
            },
			setEdit(id, val) {
				const index = this.editingRows.indexOf(id);
				if(val && index < 0){
					this.editingRows.push(id);
				}else if(!val && index > -1){
					this.editingRows.splice(index, 1);
				}
			},
			switchAssignments(type) {
				let configname = (type === 'prices' ? 'priceassignments' : 'fieldassignments'),
					value = !this.scopeorder.configuration[configname];
				this.scopeorder.configuration[configname] = value;
				if(type === 'fields')
					this.generateAssignments();
				if(this.viewform && this.scopeorder.id){
					this.$store.dispatch('set', { name: 'processing', value: true });
					this.$store.dispatch('change', {
						name: 'orders',
						data: { id: this.scopeorder.id, value },
						property: configname,
						config: true
					});
					axios.post('/api/order/config', {id: this.scopeorder.id, property: configname, value, default: this.defaultOrderConfiguration[configname]}).catch(e => {
						this.$store.dispatch('setSnack', { state: 'error', text: 'Error updating config' });
					}).then(() => {
						this.$store.dispatch('set', { name: 'processing', value: false });
					});
				}
			},
			totalChanged (total, index){
				let valueindex = _.findIndex(this.scopeorder.orderitems[index].fieldvalues, ['field_id', this.totalField.id]);
				if(valueindex > -1)
					this.scopeorder.orderitems[index].fieldvalues[valueindex].value = total
				this.scopeorder.orderitems[index].total = total;
			}
        },
		props: {
			order: {
				required: true,
			},
			department: {
				type: Object
			},
			overrides: {
				type: Object
			},
			viewform: {
				type: Boolean
			},
			type: {
				type: String,
				default: 'order'
			}
		},
		watch: {
			order: {
				handler (val) {
					if(val && !this.scopeorder){
						let temporder = _.cloneDeep(val),
							defaultObj = _.cloneDeep(this.defaultOrderConfiguration);

						if(this.department)
							defaultObj['h'+this.department.id] = [];

						if(!Object.keys(temporder).length)
							temporder = _.cloneDeep(this.defaultOrder);

						temporder.configuration = Object.assign({}, defaultObj, temporder.configuration);
						this.scopeorder = temporder;
						this.generateAssignments();
						if(!this.viewform && !this.scopeorder.orderitems.length)
							this.addOrderitem();
						this.dialog = true;
					}
				},
				deep: true,
				immediate: true
			},
			totalPrice (newVal, oldVal) {
				let fieldvalues = this.scopeorder.fieldvalues,
					valueindex = -1;
				if(fieldvalues && newVal !== oldVal){
					for(let x = 0, value; value = fieldvalues[x]; x++){
						if(value.field_id === this.orderpriceField.id){
							valueindex = x; break;
						}
					}
					if(valueindex > -1)
						this.scopeorder.fieldvalues[valueindex].value = newVal;
				}
			}
		}
    }
</script>

<style>
	.shrink-width{
		width:100px;
	}
</style>
<style scoped lang="scss">
	.delete-item-btn{
		display:none;
	}
	.item-row:hover .delete-item-btn{
		display:block;
	}
	.os-order-footer{
		position:relative;
		height:76px;

		> div{
			position:absolute;
			right:0;
			top:11px;
			margin-right:40px;

			width:142px;
		}
	}
</style>
